import css from 'styled-jsx/css'
import btnStyles from '../Button/styles'

const overlayBg = 'rgba(21, 21, 21, 0.9)'
/*
  const inputBg = 'rgba(71, 71, 71)'
  const inputBorder = 'rgba(196, 72, 240, 1)'
  const buttonBg = 'rgba(153, 22, 199, 1)'
  const buttonBgHover = 'rgba(196, 72, 240, 1)'
*/
export const buttonStyles = btnStyles

export const overlayStyles = css`
@keyframes anim {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.overlay-container {
  position: relative;
  min-width: 100%;
  animation-delay: 10ms;
  animation: dissolve;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
  transform: translateX(-100%);
  display: flex;
  z-index: 10;
  justify-content: flex-start;
  background-color: ${overlayBg};
  padding: 100px 25px 48px 25px;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: scroll;
}
@-webkit-keyframes dissolve {
  100% {
    opacity: 1;}
  0% {
    opacity: 0;}
}
@keyframes dissolve {
  100% {
    opacity: 1;}
  0% {
    opacity: 0;}
}
.overlay-container :global(form) {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
}

.entering {
  animation: anim .3s linear forwards;
}

.entered {
  opacity: 1;
  z-index: 2;
}

.exiting {
  animation: anim .3s linear forwards reverse;
}

@media (max-width: 767px) {
  .overlay-container {
    padding: 80px 25px 48px 25px;
  }
}
`

export const searchStyles = css`
.container {
  width: 100%;
  max-width: 1024px;
}
`
export const categoryListStyles = css`
.category-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  color: #C4C4C4;
}

.category-list :global(li) {
  margin-right: 1em;
  position: relative;
  display: inline-block;
  white-space: nowrap;
}

.category-list :global(li:not(:last-of-type):after) {
  content: '|';
  position: absolute;
  right: -0.6em;
}
`
